// Global function to handle property note submission
window.handlePropertyNoteSubmit = function(event, button) {
  console.log('Save button clicked!');
  event.preventDefault();
  
  const form = $(button).closest('.property-note-form');
  const url = form.data('url');
  const noteId = form.data('id');
  const method = 'POST';
  const propertyId = form.data('property-id');
  
  console.log('Form data:', {
    url: url,
    noteId: noteId,
    method: method
  });

  // Get the authenticity token
  const token = form.find('input[name="authenticity_token"]').val();
  
  // Disable the button and show loading state
  const btn = $(button);
  btn.prop('disabled', true).text('Submitting...');
  
  // Prepare the data
  const data = {
    'property_note[id]': noteId,
    'property_note[visited_by_id]': form.find('#property_note_visited_by_id').val(),
    'property_note[property_visited_date]': form.find('#property_note_property_visited_date').val(),
    'property_note[description]': form.find('#property_note_description').val(),
    'property_note[window]': form.find('#property_note_window').val(),
    'property_note[roof]': form.find('#property_note_roof').val(),
    'property_note[vacancy]': form.find('#property_note_vacancy').val(),
    'property_note[garage]': form.find('#property_note_garage').val(),
    'authenticity_token': token
  };

  console.log('Sending data:', data);
  
  // $.ajax({
  //   url: url,
  //   method: method,
  //   data: data,
  //   dataType: 'json',
  //   success: function(response) {
  //     console.log('Success response:', response);
  //     if (response.success) {
  //       // Close the modal
  //       form.closest('.modal').modal('hide');
        
  //       // Show success message
  //       toastr.success(response.message || 'Note updated successfully');
        
  //       // Reload the page after 5 seconds
  //       setTimeout(function() {
  //         window.location.reload();
  //       }, 3000);
  //     }
  //   },
  //   error: function(xhr) {
  //     console.log('Error response:', xhr);
  //     let errors;
  //     try {
  //       errors = xhr.responseJSON.errors;
  //     } catch(e) {
  //       errors = ['An error occurred while saving'];
  //     }
  //     const errorDiv = form.find('.form-errors');
  //     errorDiv.removeClass('d-none').html(errors.join('<br>'));
  //   },
  //   complete: function() {
  //     // Re-enable the button and restore text
  //     btn.prop('disabled', false).text(noteId ? 'Update' : 'Save');
  //   }
  // });
};


function initializePropertyNote() { 
    let currentNoteType = 'note';
  
    $('#add_property_note').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget);
      const modal = $(this);
      const form = modal.find('form');
  
      const isExistingNote = form.data('note-id');
  
      if (isExistingNote) {
        currentNoteType = form.data('is-inspection') ? 'inspection' : 'note';
      } else {
        currentNoteType = button.data('note-type') || 'note';
      }
  
      const title = currentNoteType === 'inspection' ? 'Add Property Inspection' : 'Add Property Note';
      modal.find('.modal-title').text(title);
  
      const inspectionFields = modal.find('.inspection-field');
      if (currentNoteType === 'inspection') {
        inspectionFields.show();
        inspectionFields.find('select').prop('required', true);
      } else {
        inspectionFields.hide();
        inspectionFields.find('select').prop('required', false);
        if (!isExistingNote) {
          inspectionFields.find('select').val('');
        }
      }

      // Always clear previously selected images when the modal opens so
      // inspection selections never bleed into note mode (and vice-versa)
      const noteForm = modal.find('.property-note-form');
      if (noteForm.length && window.clearPropertyNoteFiles) {
        window.clearPropertyNoteFiles(noteForm);
      }
    });
  
    // // Image Upload Handling
    // const form = document.getElementById('propertyNoteForm');
    // if (!form) return;
  
    // const fileInput = form.querySelector('input[type="file"]');
    // const uploadLabel = form.querySelector('.property-note-file-upload-label span');
    // const uploadSmall = form.querySelector('.property-note-file-upload-label small');
    // const uploadStatus = document.getElementById('property-note-upload-status');
    // const uploadPreview = form.querySelector('.property-note-upload-preview');
  
    // const cloudinaryIds = [];
    // let totalFiles = 0;
    // let uploadedFiles = 0;
  
    // fileInput.addEventListener('change', function (e) {
    //   const files = Array.from(e.target.files);
    //   if (!files.length) return;
    //   handleFiles(files);
    // });
  
    // function handleFiles(files) {
    //   totalFiles = files.length;
    //   uploadedFiles = 0;
    //   cloudinaryIds.length = 0;
  
    //   uploadLabel.textContent = `${files.length} ${files.length === 1 ? 'file' : 'files'} selected`;
    //   uploadSmall.textContent = 'Click to change';
  
    //   if (files.length > 50) {
    //     toastr.error('You can only upload up to 50 images at a time');
    //     fileInput.value = '';
    //     return;
    //   } 

    //   uploadPreview.innerHTML = '';
    //   files.forEach(file => {
    //     const reader = new FileReader();
    //     reader.onload = function (e) {
    //       const preview = document.createElement('div');
    //       preview.className = 'preview-item';
    //       preview.innerHTML = `
    //         <img src="${e.target.result}" style="max-width: 100px; max-height: 100px; margin: 5px;">
    //         <div class="progress" style="height: 5px;">
    //           <div class="progress-bar" role="progressbar" style="width: 0%"></div>
    //         </div>
    //       `;
    //       $('.property-note-upload-preview').append(preview);
    //     };
    //     reader.readAsDataURL(file);
    //   });
    // } 
  
  // Custom validation before form submission
  window.validatePropertyNoteForm = function(form) {
    const errorDiv = $(form).find('.form-errors');
    const visitedById = $(form).find('#property_note_visited_by_id').val();
    const visitedDate = $(form).find('#property_note_property_visited_date').val();
    
    // Always validate visited by and date
    if (!visitedById) {
      errorDiv.text('Please select who visited the property');
      toastr.error('Please select who visited the property');
      return false;
    }
    
    if (!visitedDate) {
      errorDiv.text('Please select a visit date');
      toastr.error('Please select a visit date');
      return false;
    }
    
    // Update isInspection value based on currentNoteType
    $(form).find('.note-type-input').val(currentNoteType === 'inspection');
    
    // Only validate inspection fields if it's an inspection note
    if (currentNoteType === 'inspection') {
      const window = $(form).find('#property_note_window').val();
      const roof = $(form).find('#property_note_roof').val();
      const garage = $(form).find('#property_note_garage').val();
      const vacancy = $(form).find('#property_note_vacancy').val();
      
      if (!window) {
        errorDiv.text('Please select Window');
        toastr.error('Please select Window');
        return false;
      }
      
      if (!roof) {
        errorDiv.text('Please select Roof');
        toastr.error('Please select Roof');
        return false;
      }
      
      if (!garage) {
        errorDiv.text('Please select Garage');
        toastr.error('Please select Garage');
        return false;
      }
      
      if (!vacancy) {
        errorDiv.text('Please select Vacancy');
        toastr.error('Please select Vacancy');
        return false;
      }
    }
    
    errorDiv.text(''); // Clear any previous errors
    return true;
  };
};


// Initialize only on Turbolinks load since it covers both scenarios
document.addEventListener('turbolinks:load', initializePropertyNote);